import type { TranslationDict } from '../en';

const cs: TranslationDict = {
  'header.buy': 'Koupit',
  'header.sell': 'Prodat',
  'spend.label': 'Utratíte',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Obdržíte',
  'payment.label': 'Platební metoda',
  'payment.select': 'Vybrat',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Pro tento pár nejsou dostupné žádné platební metody',
  'wallet.label': 'Adresa přijímací peněženky',
  'wallet.placeholderBuy': 'Zadejte svou přijímací adresu',
  'wallet.placeholderSell': 'Zadejte svou odesílací adresu',
  'wallet.validating': 'Ověřování adresy...',
  'wallet.invalid': 'Zadejte platnou adresu peněženky',
  'wallet.invalidServer': 'Neplatná adresa peněženky',
  'cta.buy': 'Koupit {crypto}',
  'cta.sell': 'Prodat {crypto}',
  'cta.gettingPrice': 'Hledáme nejlepší cenu...',
  'cta.processing': 'Zpracování...',
  'footer.poweredBy': 'Běží na ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Rozpis kurzu',
  'rate.close': 'Zavřít',
  'rate.updatesIn': 'Kurz se aktualizuje za 00:{seconds}',
  'rate.noQuote': 'Žádná nabídka není k dispozici',
  'rate.exchangeRate': 'Směnný kurz',
  'rate.processingFee': 'Poplatek za zpracování',
  'rate.networkFee': 'Síťový poplatek',
  'rate.provider': 'Poskytovatel',
  'toast.orderCreated': 'Objednávka vytvořena',
  'toast.redirecting': 'Přesměrování na platbu...',
  'toast.orderFailed': 'Objednávka selhala',
  'toast.couldNotCreate': 'Objednávku nebylo možné vytvořit',
  'toast.quoteError': 'Chyba nabídky',
  'toast.noProviders': 'Žádní poskytovatelé',
  'toast.somethingWrong': 'Něco se pokazilo',
  'error.amountZero': 'Částka musí být větší než 0',
  'error.minAmountFiat': 'Minimální částka je {min} {currency}',
  'error.minAmountCrypto': 'Minimální částka je {min} {currency}',
  'error.noProviders': 'Pro tuto kombinaci nejsou k dispozici žádní poskytovatelé',
  'error.currencyUnavailableBuy': 'Tato měna není dostupná pro nákup',
  'error.currencyUnavailableSell': 'Tato měna není dostupná pro prodej',
  'parity.info': 'Bude vám účtováno za {receiveAmount} {crypto}, zbytek do {spendAmount} {fiat} bude připsán na váš účet {partner}',
  'redirect.secureBadge': 'Bezpečná platba',
  'redirect.title': 'Pokračovat v platbě',
  'redirect.description': 'Budete přesměrováni na {gateway} k dokončení platby.',
  'redirect.countdown': 'Přesměrování za {seconds}...',
  'redirect.openTab': 'Otevřít ACH v nové kartě',
  'redirect.cancel': 'Zrušit',
  'checkout.noOrder': 'Objednávka nenalezena',
  'checkout.goBack': 'Zpět',
  'checkout.expired': 'Platba vypršela',
  'checkout.expiredDesc': 'Relace vypršela. Zkuste to prosím znovu.',
  'checkout.startOver': 'Začít znovu',
  'checkout.cancel': 'Zrušit',
  'checkout.loading': 'Načítání platby...',
  'checkout.iframeTitle': 'Platba poskytovatele',
  'checkout.widgetTitle': 'Platební pokladna',
  'checkout.unknownMethod': 'Neznámá platební metoda',
  'processing.default': 'Zpracování vaší objednávky...',
  'processing.pending': 'Čekání na potvrzení platby...',
  'processing.active': 'Zpracování vaší transakce...',
  'processing.generic': 'Zpracování...',
  'processing.checkingStatus': 'Kontrola stavu...',
  'processing.orderId': 'ID objednávky',
  'processing.provider': 'Poskytovatel',
  'processing.amount': 'Částka',
  'processing.receiving': 'Příjem',
  'processing.network': 'Síť',
  'processing.toAddress': 'Na adresu',
  'processing.usuallyMinutes': 'Obvykle to trvá několik minut.',
  'processing.safeToClose': 'Tuto stránku můžete bezpečně zavřít — po dokončení vám pošleme email.',
  'complete.buyTitle': 'Nákup dokončen!',
  'complete.sellTitle': 'Prodej dokončen!',
  'complete.buyDesc': 'Vaše {crypto} byly odeslány do vaší peněženky.',
  'complete.sellDesc': 'Vaše výplata v {fiat} se zpracovává.',
  'complete.amountBuy': 'Přijatá částka',
  'complete.amountSell': 'Prodaná částka',
  'complete.paidBuy': 'Zaplacená částka',
  'complete.paidSell': 'Částka výplaty',
  'complete.network': 'Síť',
  'complete.wallet': 'Peněženka',
  'complete.transaction': 'Transakce',
  'complete.provider': 'Poskytovatel',
  'complete.orderId': 'ID objednávky',
  'complete.completed': 'Dokončeno',
  'complete.viewExplorer': 'Zobrazit v Exploreru',
  'complete.done': 'Hotovo',
  'errorStep.failed': 'Platba selhala',
  'errorStep.cancelled': 'Objednávka zrušena',
  'errorStep.expired': 'Objednávka vypršela',
  'errorStep.refunded': 'Objednávka vrácena',
  'errorStep.unknown': 'Něco se pokazilo',
  'errorStep.failedBuy': 'Vaši platbu nebylo možné zpracovat. Zkuste to prosím znovu nebo použijte jinou platební metodu.',
  'errorStep.failedSell': 'Váš prodej nebylo možné zpracovat. Zkuste to prosím znovu.',
  'errorStep.cancelledBuy': 'Vaše objednávka byla zrušena. Žádná platba nebyla provedena.',
  'errorStep.cancelledSell': 'Váš prodej byl zrušen. Žádné krypto nebylo převedeno.',
  'errorStep.expiredBuy': 'Vaše objednávka vypršela. Zahajte prosím nový nákup.',
  'errorStep.expiredSell': 'Vaše objednávka vypršela. Zahajte prosím nový prodej.',
  'errorStep.refundedBuy': 'Vaše platba byla vrácena. Prostředky by se měly objevit na vašem účtu do 5-10 pracovních dnů.',
  'errorStep.refundedSell': 'Vaše krypto bylo vráceno. Prostředky by se měly brzy objevit ve vaší peněžence.',
  'errorStep.genericDesc': 'Došlo k neočekávané chybě. Zkuste to prosím znovu.',
  'errorStep.orderId': 'ID objednávky',
  'errorStep.tryAgain': 'Zkusit znovu',
  'errorStep.startOver': 'Začít znovu',
  'errorStep.return': 'Zpět',
  'errorStep.needHelp': 'Potřebujete pomoc? Kontaktujte ',
  'errorStep.reference': 'Reference: {orderId}',
  'confirm.buyTitle': 'Potvrdit nákup',
  'confirm.sellTitle': 'Potvrdit prodej',
  'confirm.loading': 'Načítání...',
  'confirm.provider': 'Poskytovatel',
  'confirm.youPay': 'Zaplatíte',
  'confirm.youSell': 'Prodáváte',
  'confirm.youReceive': 'Obdržíte',
  'confirm.wallet': 'Peněženka',
  'confirm.network': 'Síť',
  'confirm.refundAddress': 'Adresa pro vrácení',
  'confirm.parityNote': 'Účtovaná částka od poskytovatele se může lišit. Zbytek do {amount} {crypto} bude připsán na váš účet {partner}.',
  'confirm.processing': 'Zpracování...',
  'confirm.confirmPay': 'Potvrdit a zaplatit',
  'confirm.confirmSell': 'Potvrdit a prodat',
  'confirm.payout': 'Výplata v {currency}',
  'modal.selectFiat': 'Vyberte fiat měnu',
  'modal.selectCrypto': 'Vyberte kryptoměnu',
  'modal.choosePayment': 'Zvolte platební metodu',
  'modal.selectCountry': 'Vyberte svou zemi',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Oblíbené',
  'modal.recommended': 'Doporučené',
  'modal.noCurrencies': 'Žádné měny nenalezeny',
  'modal.noPaymentMethods': 'Žádné platební metody nenalezeny',
  'modal.noCountries': 'Žádné země nenalezeny',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Poloha',
  'settings.darkMode': 'Tmavý režim',
  'settings.privacy': 'Zásady ochrany osobních údajů',
  'settings.terms': 'Podmínky použití',
  'settings.language': 'Jazyk',
  // ─── Additional ───
  'modal.chooseRamp': 'Vyberte Ramp',
  'modal.bestPrice': 'Nejlepší cena',
  'modal.noQuotes': 'Pro tento požadavek nejsou k dispozici žádné nabídky',
  'modal.noProvidersFound': 'Žádní poskytovatelé nenalezeni',
  'payment.unavailableFor': 'Žádné platební metody pro {currency}',
  'skeleton.poweredBy': 'Běží na NowRamp',
  'error.createOrderFailed': 'Nepodařilo se vytvořit objednávku',
  'errorStep.returnToMerchant': 'Vrátit se k obchodníkovi',
  'confirm.cryptoOnNetwork': '{crypto} v síti {network}',
  'payment.name.card': 'Karta',
  'payment.name.bankTransfer': 'Bankovní převod',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default cs;
